export default "__VITE_ASSET__4e1f97b1__"